import { createApp } from 'vue'
import App from './App.vue'
//import Vue from 'vue';
import customStyles from './helpers/customStyles';

const app = createApp(App);

app.use(customStyles);

app.mount('#section-image-with-text-c');
//createApp(App).mount('.section-image-with-text-c');
